@if (
  {
    expanded: (expanded$ | async)!,
    items: (items$ | async)!,
    modalId: (modalId$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'weiterbildungsart'"
    [label]="'Weiterbildungsart'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    @if (context.expanded) {
      <now-wbsuche-lib-checkbox-facette
        [label]="'Weiterbildungsart'"
        [komponentenId]="'weiterbildungsartFacette'"
        [selectItems]="context.items"
        (selected)="updateSelectedIds($event)"
        [modalId]="context.modalId"
        [facetteLoading]="(loaderService.facettenLoading$ | async)!"
      ></now-wbsuche-lib-checkbox-facette>
    }
  </now-wbsuche-lib-basis-facette>
}
